export const keys = {
  USER: "user",
  BRANCH: "branch",
  SHIFT: "shift"
}
export const addToStorage = (key: string, data: any) => {
  data = JSON.stringify(data)
  localStorage.setItem(key, data)
}

export const getFromStorage = (key: string) => {
  const user = localStorage.getItem(key)
  return user ? JSON.parse(user) : null
}

export const removeFromStorage = (key: string) => {
  localStorage.removeItem(key)
}
